
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 4.125C7.99594 4.125 4.75 7.37094 4.75 11.375C4.75 14.2133 6.38105 16.6707 8.75699 17.861L9.87527 15.6245C8.31862 14.8446 7.25 13.2346 7.25 11.375C7.25 8.75165 9.37665 6.625 12 6.625C14.6234 6.625 16.75 8.75165 16.75 11.375C16.75 13.2346 15.6814 14.8446 14.1247 15.6245L15.243 17.861C17.619 16.6707 19.25 14.2133 19.25 11.375C19.25 7.37094 16.0041 4.125 12 4.125ZM15.914 19.2029C18.7815 17.7664 20.75 14.8006 20.75 11.375C20.75 6.54251 16.8325 2.625 12 2.625C7.16751 2.625 3.25 6.54251 3.25 11.375C3.25 14.8006 5.21851 17.7664 8.08603 19.2029L7.3618 20.6514C7.19558 20.9838 7.43733 21.375 7.80902 21.375H16.191C16.5627 21.375 16.8044 20.9838 16.6382 20.6514L15.914 19.2029ZM13.4538 14.2825C14.5188 13.7489 15.25 12.6474 15.25 11.375C15.25 9.58007 13.7949 8.125 12 8.125C10.2051 8.125 8.75 9.58007 8.75 11.375C8.75 12.6474 9.48116 13.7489 10.5462 14.2825L11.5528 12.2694C11.737 11.9009 12.263 11.9009 12.4472 12.2694L13.4538 14.2825Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowtriggereventFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
